module.exports = __webpack_public_path__ + "static/img/4.0389ebf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/zh/4.png
// module id = vfrG
// module chunks = 0